<template>
    <div class="multiple-text">
        <div class="panel">
            <Cell :title="title" :border="false" :required="isRequired" :class="{required_studio: requiredStudio}"></Cell>
            <div class="textarea-container">
                <div class="textarea_out">
                    <Field
                        class="text-field"
                        :value="value"
                        :border="false"
                        :disabled="isDisable"
                        @blur="$emit('blur')"
                        @input="changeField"
                        type="textarea"
                        :maxlength="limted"
                        :placeholder="placeholder"
                        rows="1"
                        autosize
                    />
                    <div class="textarea_out-simple"><span>{{value.length}}</span>/{{limted}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Cell, Field } from 'vant';

    export default {
        props: {
            value: {
                type: String,
                default: ''
            },
            title: String,
            placeholder: String,
            limted: {
                type: Number,
                default: 100
            },
            isRequired: {
                type: Boolean,
                default: false
            },
            requiredStudio: { // 用于工作室的星号颜色
                type: Boolean,
                default: false
            },
            isDisable: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                showExample: false,
            }
        },
        methods: {
            changeField(val) {
                this.$emit('input', val)
            },
        },
        components: { Cell, Field }
    }
</script>
<style lang="scss" scoped>
    // 文本域容器
    .multiple-text{
        background: rgba(243, 245, 249, 1);
        padding-bottom: 5px;
        .panel {
            background: rgba(255, 255, 255, 1);
            padding-left: 5px;
            .van-cell--required.required_studio {
                &::before {
                    color: #ffbc2a;
                }
            }
        }
        .textarea-container {
            .textarea_out {
                padding-left: 11px;
                padding-right: 16px;
                padding-bottom: 16px;
                overflow: hidden;
                &-simple {
                    padding-top: 17px;
                    text-align: right;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(150, 159, 169, 1);
                    &>span {
                        color: rgba(248, 64, 37, 1);
                    }
                }
                .text-field {
                    background: rgba(250, 250, 250, 1);
                    .van-field__control {
                        font-size:14px;
                        font-weight:400;
                        color:rgba(102,102,102,1);
                        line-height:22px;
                        padding-top: 10px;
                        padding-bottom: 10px;
                    }
                }
            }
        }
    }
</style>